// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dc482dfd","977":"885de9d3"}[chunkId] + ".chunk.js";
};